$( document ).ready(function() {
    $('.cls-lbl-cover p').text($('.cls-lbl').text());
    $( ".swatches__swatch--color input" ).click(function() {
      $('.cls-lbl-cover p').text($(this).val());
    });
});

$('.charity_image_slider .img_block_main_imgs').slick({
  dots: false,
  infinite: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});

$('.ann-slider').slick({
  dots: false,
  infinite: true,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000
});

$('.log-slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
});
  
$('.slider-main').slick({
  slidesToShow: 1,
  arrows: false,
  asNavFor: '.slider-nav',
  vertical: true,
  verticalSwiping: true,
  autoplay: false,
  adaptiveHeight:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          arrows: false,
         verticalSwiping: false,
      }
    }, 
    {
      breakpoint: 767,
      settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          arrows: false,
        verticalSwiping: false,
      }
    }
  ]
});

$('.slider-nav').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: '.slider-main',
  dots: false,
  infinite:true,
  focusOnSelect: true,
  verticalSwiping: true,
  vertical: true,
  autoplay: false,
  arrows: true,
  prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/left.jpg?v=1579609299'></button>",
  nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/right.jpg?v=1579609299'></button>",
  responsive: [{
    breakpoint: 1024,
    settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: false,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/left.jpg?v=1579609299'></button>",
        nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/right.jpg?v=1579609299'></button>"
   }
 },
 {
    breakpoint: 767,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/left.jpg?v=1579609299'></button>",
        nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0941/4302/files/right.jpg?v=1579609299'></button>"
    }
 }]
});

// Quick & dirty toggle to demonstrate modal toggle behavior
$('.modal-toggle').on('click', function(e) {
  e.preventDefault();
  var img1 = $(this).attr('data-img1');
  var img2 = $(this).attr('data-img2');

  if(img1 != ''){
    $(".modal-content img").remove();
    $('.modal-content').append("<img src="+ img1 +" />");
  }else{
    $(".modal-content img").remove();
    $('.modal-content').append("<img src="+ img2 +" />");
  } 
  $('.modal').toggleClass('is-visible');
  $('html, body').animate({
        scrollTop: $("#press-imgs").offset().top
  }, 100);
});

$('.modal-toggle-logo').on('click', function(e) {
  e.preventDefault();
  $('.modal-logo').toggleClass('is-visible');
});

$('.modal-toggle-video').on('click', function(e) {
  e.preventDefault();
  $('.modal-video').toggleClass('is-visible');
});

$('.modal-toggle-inspir').on('click', function(e) {
  e.preventDefault();
  $('.modal-inspir').toggleClass('is-visible');
});

// Default product
$(document).ready(function(){ 
    $(".template-product .image-thumbnail img").on("click",function() { 
      var variant_id = $(this).attr('data-variant');    
      $(".template-product .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });
}); 

// 22 Size product
$(document).ready(function(){ 
    $(".template-product-color-chain-size-22 .image-thumbnail img").on("click",function() { 
      var variant_id = $(this).attr('data-variant');    
      $(".template-product-color-chain-size-22 .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });
}); 
$(document).ready(function(){ 
    $('.accounts__recover-password').on('click', function(e) {
      $('#customer-login').hide();
      $('[data-wau-modal-content="recover-password"]').show();
    }); 
}); 
// Color product
$(document).ready(function(){ 
    $(".template-product-color #thumbnails .image-thumbnail img").on("click",function() { 
      var variant_id = $(this).attr('data-variant');    
      $(".template-product-color .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });
}); 


// Color Size product
$(document).ready(function(){ 
    $(".template-product-color-size #thumbnails .image-thumbnail img").on("click",function() { 
      var variant_id = $(this).attr('data-variant');    
      $(".template-product-color-size .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });
}); 

// Front Back product
$(document).ready(function(){ 
    setTimeout(function() {
      var class_id = $(".template-product-variant-front-back #thumbnails .image-thumbnail.is-nav-selected .product-single__thumbnail img").attr("data-variant");
      console.log(class_id);
      $(".template-product-variant-front-back .hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == class_id){   
          $(this).show();
        }
      });
    }, 1000);  

    $(".template-product-variant-front-back #thumbnails .image-thumbnail img").on("click",function() { 
      $(".template-product-variant-front-back .hidden_gallery").css("display","none");
      var variant_id = $(this).attr('data-variant');    
      $(".template-product-variant-front-back .hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == variant_id){   
          $(this).show();
        }
      });
      $(".template-product-variant-front-back .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });

    $(".template-product-variant-front-back .swatches__container .swatches__swatch--color label").on("click",function() { 
      $(".template-product-variant-front-back .hidden_gallery").css("display","none");
      var variant_id = $(this).attr('v-id')
      $(".template-product-variant-front-back .hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == variant_id){   
          $(this).show();
        }
      });
    });  
  
}); 

// 2way convert product
$(document).ready(function(){ 
    setTimeout(function() {
      var class_id = $(".template-product-2way-convert #thumbnails .image-thumbnail.is-nav-selected .product-single__thumbnail img").attr("data-variant");
      console.log(class_id);
      $(".template-product-2way-convert .hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == class_id){   
          $(this).show();
        }
      });
    }, 1000);  

    $(".template-product-2way-convert #thumbnails .image-thumbnail img").on("click",function() { 
      $(".template-product-2way-convert .hidden_gallery").css("display","none");
      var variant_id = $(this).attr('data-variant');    
      $(".template-product-2way-convert .hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == variant_id){   
          $(this).show();
        }
      });
      $(".template-product-2way-convert .swatches__container .swatches__swatch--color label").each(function() {  
        if($(this).attr('v-id') == variant_id){
          $(this).parent().children('input').trigger('click');
        }  
      });  
    });

    $(".template-product-2way-convert .swatches__container .swatches__swatch--color label").on("click",function() { 
      $(".template-product-2way-convert .hidden_gallery").css("display","none");
      var variant_id = $(this).attr('v-id')
      $(".hidden_gallery").each(function() {   
        if($(this).attr('data-alt') == variant_id){   
          $(this).show();
        }
      });
    });  
});  

// Gift functionality for product page checkbox

$(document).ready(function(){ 
  $("#gif-product-id").on("click",function() {
    if($(this).is(":checked")){
      $('#git-text').show('slow');
      $( "#gift_text" ).remove();
      $('.product__form-buttons').append( '<input id="gift_text" type="hidden" name="properties[Personalized Gift Note]" />' );
      $( "#git-text" ).val('');
    } else {
      $('#git-text').hide('slow');
      $( "#gift_text" ).remove();
    }
  });

  $("#git-text").keyup(function(){
    var flag = $( ".product__form-buttons" ).find( "#gift_text" ).length;
    if(flag == 0){
      $('.product__form-buttons').append( '<input id="gift_text" type="hidden" name="properties[Personalized Gift Note]" />' );
    } 
    $("#gift_text").val($(this).val());
  });
});  


// MATCH HEIGHT JS START

var matchHeight = function (selector) {
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = 'auto';
    if (elements[i].offsetHeight > maxHeight) {
      maxHeight = elements[i].offsetHeight;
    }
  }
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
  }
};

window.onload = function () {
  matchHeight('.step_items .step_item .step_item_wrapper');
  matchHeight('.index_college_columns .collage_text_cover');
};

window.onresize = function () {
  matchHeight('.step_items .step_item .step_item_wrapper'); 
  matchHeight('.index_college_columns .collage_text_cover'); 
};

matchHeight('.step_items .step_item .step_item_wrapper');
matchHeight('.index_college_columns .collage_text_cover');

// MATCH HEIGHT JS END

// WRAP ALL IN ONE DIV JS START

setTimeout(function() {
    var elements = document.querySelectorAll('.pcf_item');
    var wrapper = document.createElement('div');
    wrapper.className = 'pcf_items';

    elements.forEach(function(element) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    });
}, 500);

setTimeout(function() {
    var elements = document.querySelectorAll('.cl_input-field');
    var wrapper = document.createElement('div');
    wrapper.className = 'cl_input-field-wrapper';

    elements.forEach(function(element) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    });
}, 500);

setTimeout(function() {
    var elements = document.querySelectorAll('.footer-block-menu');
    var wrapper = document.createElement('div');
    wrapper.className = 'footer-block-menu-wrapper';

    elements.forEach(function(element) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    });
}, 500);


// WRAP ALL IN ONE DIV JS END


